import { jsx as _jsx } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
import { WPQTTabs } from "../../WPQTTabs";
import { LogsTabContent } from "./LogsTabContent";
import { PrivateCommentsTabContent } from "./PrivateCommentsTabContent";
import { PublicCommentsTabContent } from "./PublicCommentsTabContent";
function UserModalTabs({ user }) {
    const tabs = [
        __("Private comments", "quicktasker"),
        __("Public comments", "quicktasker"),
        __("Logs", "quicktasker"),
    ];
    return (_jsx(WPQTTabs, { tabs: tabs, tabsContent: [
            _jsx(PrivateCommentsTabContent, { userId: user.id }, 1),
            _jsx(PublicCommentsTabContent, { userId: user.id }, 2),
            _jsx(LogsTabContent, { userId: user.id }, 3),
        ] }));
}
export { UserModalTabs };
